import * as consts from '../constants';
import * as commonActions from './commonActions';
import userApi from '../api/userApi';

export function loadAgentsSuccess(pagingModel) {
    return { type: consts.ACTONS.LOAD_AGENTS_SUCCESS, pagingModel };
}

export function loadAgentsFailed() {
    return { type: consts.ACTONS.LOAD_AGENTS_FAILED };
}

export function loadAgents(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.loadAgents(getState().authenticationState.token, pagingModel).then(res => {
            res.roleId = pagingModel.roleId;
            res.name = pagingModel.name;
            res.surname = pagingModel.surname;
            res.username = pagingModel.username;
            dispatch(commonActions.unlockScreen());
            dispatch(loadAgentsSuccess(res));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadAgentsFailed());
            throw (error);
        });
    };
}

export function loadAgentsByNetowrk(networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.loadUsersByNetowrk(getState().authenticationState.token, networkId, consts.AUTHENTICATION.USER_ROLE.NetworkAgent).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadUsersSuccess(pagingModel) {
    return { type: consts.ACTONS.LOAD_USERS_SUCCESS, pagingModel };
}

export function loadUsersFailed() {
    return { type: consts.ACTONS.LOAD_USERS_FAILED };
}

export function loadUsers(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.loadUsers(getState().authenticationState.token, pagingModel).then(res => {
            res.name = pagingModel.name;
            res.surname = pagingModel.surname;
            res.username = pagingModel.username;
            res.roleId = pagingModel.roleId;
            dispatch(commonActions.unlockScreen());
            dispatch(loadUsersSuccess(res));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadUsersFailed());
            throw (error);
        });
    };
}

export function loadUser(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.loadUser(getState().authenticationState.token, id).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadBasicUser(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.loadBasicUser(getState().authenticationState.token, id).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveAgent(user) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.saveUser(getState().authenticationState.token, user).then(savedUser => {
            dispatch(commonActions.unlockScreen());
            // Reload Users
            dispatch(loadAgents(getState().agentState));
            return savedUser;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveUser(user) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.saveUser(getState().authenticationState.token, user).then(savedUser => {
            dispatch(commonActions.unlockScreen());
            // Reload Users
            dispatch(loadUsers(getState().userState));
            return savedUser;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveBasicUser(user) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.saveBasicUser(getState().authenticationState.token, user).then(savedUser => {
            dispatch(commonActions.unlockScreen());
            return savedUser;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

// *******************************************************************************************************************
//                                                      Documents 
// *******************************************************************************************************************
export function eliminaDocumento(documentId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.eliminaDocumento(getState().authenticationState.token, documentId).then((user) => {
            dispatch(commonActions.unlockScreen());
            return user;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function caricaDocumento(userId, file) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.caricaDocumento(getState().authenticationState.token, userId, file).then(user => {
            dispatch(commonActions.unlockScreen());
            return user;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}
